import { Component, Input } from '@angular/core';
import { BannerHeadingConfig } from '../../../../../atoms/heading/models/heading.interface';
import { CSSProperties } from './../../../../../../models/styles.interfaces';

@Component({
  selector: 'idp-heading',
  templateUrl: './banner-heading.component.html',
  styleUrls: ['./banner-heading.component.scss']
})
export class BannerHeadingComponent {
  @Input()
  content: BannerHeadingConfig = {} as BannerHeadingConfig;

  @Input()
  styles: CSSProperties = {} as CSSProperties;

  /** prepare heading class according to the position */
  get headingClass(): string {
    const { fontWeight } = this.styles;
    return `${
      // eslint-disable-next-line no-extra-boolean-cast
      !!this.styles.position
        ? 'text-align-' + this.styles.position
        : 'text-align-left'
    } text-weight--${fontWeight}`;
  }
}
